import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import {
  ChevronDown,
  ChevronRight,
  InboxIcon,
  PersonIcon,
  StarOutline,
  Vivier,
} from '../../../../assets/icons';
import UseContext from '../../../../hooks/useContext';
import useVivierCounts from '../../../../hooks/useVivierCounts';
import Badge from '../../../badge/badge';
import SidebarUnitDesktop from '../../components/SidebarUnitDesktop';

const VivierTaleez = () => {
  const { refreshUntreated } = UseContext();
  const location = useLocation();
  const pathname = location.pathname;
  const [vivierExpanded, setVivierExpanded] = useState(
    localStorage.getItem('vivier-expanded') === 'true'
  );
  
  // Utiliser le hook pour récupérer nbAllViviers et nbRatingUntreatedTempWorkers
  const { nbAllViviers, nbRatingUntreatedTempWorkers, isLoading: isLoadingCounts } = useVivierCounts(refreshUntreated);

  useEffect(() => {
    localStorage.setItem('vivier-expanded', vivierExpanded);
  }, [vivierExpanded]);

  return (
    <>
      <SidebarUnitDesktop 
        routeName={'Viviers'} 
        routeSidebar={null}
        icon={Vivier}
        text="Viviers"
        activePatterns={['/vivier', '/listAllVivier', '/ficheVivier', '/vivier-rating-temp-worker']}
        expandOnly={true}
        onExpandClick={() => setVivierExpanded(!vivierExpanded)}
      >
        {vivierExpanded ? (
          <ChevronDown wh={20} color={pathname.includes('vivier') ? '#C2410C' : '#374151'} />
        ) : (
          <ChevronRight wh={20} color={pathname.includes('vivier') ? '#C2410C' : '#374151'} />
        )}
      </SidebarUnitDesktop>
      {vivierExpanded && (
        <>
          <SidebarUnitDesktop
            routeName={'Candidats'}
            routeSidebar={'/vivier'}
            icon={PersonIcon}
            iconColor="#374151"
            text="Candidats"
            isSubItem={true}
            exactMatch={true}
          />
          <SidebarUnitDesktop
            routeName={'Tous les viviers'}
            routeSidebar={'/listAllVivier'}
            icon={InboxIcon}
            iconColor="#374151"
            text="Tous les viviers"
            isSubItem={true}
          >
            {isLoadingCounts ? (
              <div className="w-6 h-6 bg-gray-200 rounded"></div>
            ) : (
              <Badge color={'SECONDARY'}>
                <div>
                  {nbAllViviers}
                </div>
              </Badge>
            )}
          </SidebarUnitDesktop>
          <SidebarUnitDesktop
            routeName={'Avis'}
            routeSidebar={'/vivier-rating-temp-worker/rating-untreated'}
            icon={StarOutline}
            iconColor="#374151"
            text="Avis"
            isSubItem={true}
          >
            {isLoadingCounts ? (
              <div className="w-6 h-6 bg-gray-200 rounded"></div>
            ) : (
              <Badge color={'SECONDARY'}>
                <div>
                  {nbRatingUntreatedTempWorkers}
                </div>
              </Badge>
            )}
          </SidebarUnitDesktop>
        </>
      )}
    </>
  );
};

export default VivierTaleez;
